import supabase from '../supabase/supabase';
import {createSeedData} from './seed';
import {upsertFishingSessions} from './sessionRepository';

export const DEMO_GUIDE_ID='guide_demo';
export const RESET_MARKER='__SOSBOOKING_DEMO_RESET__';

const TABLES={
  guides: 'guides_1789506688831',
  tripTypes: 'trip_types_1789506688831',
  sessions: 'fishing_sessions_1789506688831',
  reservations: 'reservations_1789506688831',
  adjustments: 'seat_adjustments_1789506688831',
  waitlists: 'waitlist_entries_1789506688831',
  refunds: 'stripe_inventory_collision_refunds_1789618507617'
};

const typePayload=(type)=> ({
  id: type.id,
  guide_id: DEMO_GUIDE_ID,
  name: type.name,
  description: type.description,
  duration_hours: type.duration_hours,
  price_per_seat: type.price_per_seat,
  deposit_per_seat: type.deposit_per_seat,
  default_capacity: type.default_capacity,
  default_start_time: type.default_start_time,
  active: true,
  created_at: type.created_at,
  updated_at: new Date().toISOString()
});

export async function resetDemoEnvironment() {
  const seed=createSeedData();
  const now=new Date().toISOString();

  const {data: sessions,error: sessionError}=await supabase
    .from(TABLES.sessions)
    .select('id')
    .eq('guide_id',DEMO_GUIDE_ID);

  if (sessionError) throw sessionError;

  const sessionIds=(sessions || []).map((row)=> row.id);

  if (sessionIds.length) {
    const {error}=await supabase
      .from(TABLES.reservations)
      .update({
        customer_name: '',
        customer_email: '',
        customer_phone: '',
        customer_message: RESET_MARKER,
        party_size: 1,
        price_per_seat: 0,
        deposit_per_seat: 0,
        trip_total: 0,
        deposit_due: 0,
        deposit_paid: 0,
        balance_remaining: 0,
        payment_date: null,
        payment_status: 'RESET',
        marketing_opt_in: false,
        marketing_opt_in_at: null,
        marketing_consent_version: null,
        discount_amount: 0,
        discount_eligible: false,
        gift_card_code: '',
        status: 'CANCELLED',
        stripe_payment_id: null,
        stripe_checkout_session_id: null,
        confirmed_at: null,
        cancelled_at: now
      })
      .in('trip_session_id',sessionIds);

    if (error) throw error;

    const waitlistResult=await supabase
      .from(TABLES.waitlists)
      .update({
        name: '',
        email: '',
        phone: '',
        message: RESET_MARKER,
        party_size: 1,
        status: 'REMOVED',
        handled_at: now
      })
      .in('trip_session_id',sessionIds);

    if (waitlistResult.error) throw waitlistResult.error;

    const adjustmentResult=await supabase
      .from(TABLES.adjustments)
      .update({
        quantity: 0,
        reason: RESET_MARKER
      })
      .in('trip_session_id',sessionIds);

    if (adjustmentResult.error) throw adjustmentResult.error;

    const refundResult=await supabase
      .from(TABLES.refunds)
      .select('id')
      .in('trip_session_id',sessionIds);

    if (refundResult.error) throw refundResult.error;

    if (refundResult.data?.length) {
      for (const refund of refundResult.data) {
        const result=await supabase
          .from(TABLES.refunds)
          .update({
            stripe_checkout_session_id: `reset_checkout_${refund.id}`,
            stripe_payment_id: `reset_payment_${refund.id}`,
            refund_id: `reset_refund_${refund.id}`,
            status: 'REFUNDED',
            refunded_at: now
          })
          .eq('id',refund.id);

        if (result.error) throw result.error;
      }
    }
  }

  const archiveTypes=await supabase
    .from(TABLES.tripTypes)
    .update({
      active: false,
      description: RESET_MARKER,
      updated_at: now
    })
    .eq('guide_id',DEMO_GUIDE_ID);

  if (archiveTypes.error) throw archiveTypes.error;

  const archiveSessions=await supabase
    .from(TABLES.sessions)
    .update({
      status: 'CLOSED',
      notes: RESET_MARKER,
      updated_at: now
    })
    .eq('guide_id',DEMO_GUIDE_ID);

  if (archiveSessions.error) throw archiveSessions.error;

  const guideResult=await supabase
    .from(TABLES.guides)
    .upsert({
      ...seed.guide,
      updated_at: now
    });

  if (guideResult.error) throw guideResult.error;

  const typesResult=await supabase
    .from(TABLES.tripTypes)
    .upsert(seed.tripTypes.map(typePayload));

  if (typesResult.error) throw typesResult.error;

  await upsertFishingSessions(seed.sessions,'resetDemoEnvironment');

  const adjustmentsResult=await supabase
    .from(TABLES.adjustments)
    .upsert(seed.adjustments);

  if (adjustmentsResult.error) throw adjustmentsResult.error;
}